import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { SpiritoryWebEndpoints } from '@/types/api/api-v2';
import envPublic from '@/config/env.public';
const axiosInstance = axios.create({
  baseURL: envPublic.NEXT_PUBLIC_BASE_URL + '/api',
});

export const spiritoryWebApi = {
  get: async <T = any>(
    endpoint: SpiritoryWebEndpoints,
    config: AxiosRequestConfig<T> = {}
  ): Promise<AxiosResponse<T, any>> => {
    try {
      const response = await axiosInstance.get(endpoint, {
        ...config,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  post: async <T = any>(
    endpoint: SpiritoryWebEndpoints,
    data: any,
    config: AxiosRequestConfig<T> = {}
  ): Promise<AxiosResponse<T, any>> => {
    try {
      const response = await axiosInstance.post(endpoint, data, {
        ...config,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  put: async <T = any>(
    endpoint: SpiritoryWebEndpoints,
    data: any,
    config: AxiosRequestConfig<T> = {}
  ): Promise<AxiosResponse<T, any>> => {
    try {
      const response = await axiosInstance.put(endpoint, data, {
        ...config,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  delete: async <T = any>(
    endpoint: SpiritoryWebEndpoints,
    config: AxiosRequestConfig<T> = {}
  ): Promise<AxiosResponse<T, any>> => {
    try {
      const response = await axiosInstance.delete(endpoint, {
        ...config,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  patch: async <T = any>(
    endpoint: SpiritoryWebEndpoints,
    data: any,
    config: AxiosRequestConfig<T> = {}
  ): Promise<AxiosResponse<T, any>> => {
    try {
      const response = await axiosInstance.patch(endpoint, data, {
        ...config,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
